
import $ from 'jquery';

import intlTelInput from './non-es6/intl-tel-input-master/build/js/intlTelInput.min'; //eslint-disable-line no-unused-vars
//import  utils       from './non-es6/intl-tel-input-master/build/js/utils';
//import intlTelInput  from 'imports-loader?window=>{}!exports-loader?intlTelInput!./non-es6/intl-tel-input-master/build/js/intlTelInput';
//import utils        from 'imports-loader?window=>{}!exports-loader?utils!./non-es6/intl-tel-input-master/build/js/utils';

//not final version . this needs updates
export const mobileMasker = () => {
	
	const mobileInput = $('#U_Mobile');

	if( mobileInput.length > 0){
		 mobileInput.intlTelInput(
		 {
				utilsScript: '/dist/utils.js',
				hiddenInput: 'int_mobile_no',
				autoPlaceholder: 'off',
				autoHideDialCode: true
		 });
	   $('#U_Mobile').closest(".inputGroup").find("label").appendTo(".intl-tel-input ");
	}
 
};

